<template>
  <div
    v-click-outside="clickOutside"
    class="dropdown"
  >
    <button
      class="btn dropdown-toggle btn-sm m-2"
      :class="buttonActiveClass"
      type="button"
      data-bs-toggle="dropdown"
      aria-expanded="false"
      @click="toggleMenu"
    >
      <span class="badge bg-dark mr-2 px-2 py-1">{{ notifications }}</span>{{ label }}
    </button>
    <ul
      v-if="showMenu"
      class="dropdown-menu show"
    >
      <li
        v-for="item in items"
        :key="item.id"
        :link="item.link"
        :text="item.text"
      >
        <a
          :href="item.link"
          class="dropdown-item"
          target="_blank"
        >{{
          item.text
        }}</a>
      </li>
    </ul>
  </div>
</template>
<script>
// import { EventBus } from "../../event-bus";
import { Echo } from '../../plugins/pusher';

export default {
  name: 'NotificationMenu',
  props: {
    buttonClass: { type: String, default: 'btn-outline-primary' },
    label: { type: String, default: 'Notification Label' },
    listenFor: { type: String, default: '' },
    templateText: { type: String, default: '' },
    baseLink: { type: String, default: '' },
  },
  data() {
    return {
      items: [],
      notifications: 0,
      showMenu: false,
    };
  },
  computed: {
    buttonActiveClass() {
      return this.items.length == 0
        ? `${this.buttonClass} disabled`
        : this.buttonClass;
    },
  },
  mounted() {
    if (this.listenFor != '') {
      Echo.join(`agent.${window.appState.user.agent_id}`).listen(
        this.listenFor,
        (data) => {
          this.notifications += 1;
          this.items.splice(0, 0, {
            id: data.id,
            text: eval(this.templateText.toString()),
            link: this.baseLink.toString() + data.id,
          });
        },
      );
      // EventBus.$on(this.listenFor, (data) => {
      //   this.notifications = this.notifications + 1;
      //   this.items.splice(0, 0, {
      //     id: data.id,
      //     text: eval(this.templateText.toString()),
      //     link: this.baseLink.toString() + data.id,
      //   });
      // });
    }
  },
  methods: {
    toggleMenu() {
      this.notifications = 0;
      this.showMenu = !this.showMenu;
    },
    clickOutside() {
      if (this.showMenu) {
        this.showMenu = false;
      }
    },
  },
};
</script>
